module.exports = __webpack_public_path__ + "img/cases-part1-8.aaca88e1.png";